import React, { Component } from "react";
import Constant from "../../../Constant.js";
import Swal from "sweetalert2";

export default class LandingPageBannerWithLogin extends Component {
  state = {}
  onLogin = (e) => {
    e.preventDefault();

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("email", this.state.email);
    urlencoded.append("password", this.state.password);
    urlencoded.append("siteName", window.location.hostname.split('.')[0]);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/user/login", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.role[0].name == "Trainer" || result.role[0].name == "trainer" || result.role[0].name == "TRAINER") {
          window.location.href = "#/trainer/dashboard";
          localStorage.setItem("livelms_role", "trainer");
        } else if (result.role[0].name == "Learner" || result.role[0].name == "learner" || result.role[0].name == "LEARNER") {
          window.location.href = "#/learner/course-list";
          localStorage.setItem("livelms_role", "learner");
        } else if (result.role[0].name == "Admin" || result.role[0].name == "admin" || result.role[0].name == "ADMIN") {
          localStorage.setItem("livelms_role", "admin");
          localStorage.setItem("livelms_view", "true");
          window.location.href = "#/admin/dashboard";
        }

        localStorage.setItem("livelms_auth", result.auth);
        localStorage.setItem("livelms_login", true);

        localStorage.setItem("livelms_firstName", result.firstName);
        localStorage.setItem("lms_site_id", result.site.id);
        localStorage.setItem("lms_uid", result.id);
        localStorage.setItem("lms_zconfig", JSON.stringify(result.zoomConfig));
        localStorage.setItem("lms_site_name", result.site.name);
        if (result.site.Medium !== null) {
          localStorage.setItem("lms_site_logo", result.site.Medium.url);
        }

        window.location.reload();
      })
      .catch((error) =>
        Swal.fire("Error", "Incorrect email and password!", "error")
      );
  };
  onInputChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
    console.log(this.state);
  };
  render() {
    return (
      <div class="py-5 c2a10">
        <div class="container">
          <div class="row">
            <div class="col-md-5 text-center both-space">
              <div class="card">
                <div class="card-body">
                  <form>
                    <p className="hint-text">Email Login</p>
                    <div className="alert p-0 py-2 alert-danger text-center login-error d-none">
                      Email or password is incorrect
                          </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Email address"
                        required="required"
                        onChange={this.onInputChange}
                        value={this.state.email}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        placeholder="Password"
                        required="required"
                        onChange={this.onInputChange}
                        value={this.state.password}
                      />
                    </div>
                    <input
                      type="submit"
                      onClick={this.onLogin}
                      className="btn btn-primary btn-block"
                      value="Login"
                    />
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
